"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventiviPolizzeService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
class PreventiviPolizzeService {
    updatePreventiviPolizze(param) {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        let splitted = "";
        if (param.dataNascita.indexOf("/") > -1) {
            splitted = param.dataNascita.split("/");
        }
        else {
            splitted = param.dataNascita.toIsoString();
        }
        const body = {
            codAgenzia: param.codAgenzia,
            email: param.email,
            check: {
                targa: param.targa,
                dataNascita: splitted[2] + "-" + splitted[1] + "-" + splitted[0],
            },
        };
        /* const request = new Request('preventivatore/auto/v1/quotazioni/' + param.idQuotazione, { body: { "codAgenzia": param.codAgenzia } }); */
        const request = new request_1.Request("quotatori/auto/v2/transazioni/mieQuotazioni/" + param.idSessione, { body });
        // const request = new Request('preventivatore/auto/v1/mieQuotazioni/' + param.idQuotazione, { body: bdy });
        return commonNetworkService.post(request.completeUrl, request.body, request.headers);
    }
}
exports.PreventiviPolizzeService = PreventiviPolizzeService;
